export function StepCartEmptyState() {
  return <p className="text-sm text-muted-foreground">O carrinho ainda está vazio!</p>;
}
